import { companyInfo } from "@/mocks/home";
import logo from "@/assets/logo.png";

export default function Footer() {
  return (
    <footer className="bg-background-50 border-t border-background-300/30">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          

          <div className="border-t border-background-300/30 pt-8">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8">
            <a className="flex items-center gap-3 group">
            <img src={logo} alt="" className="h-10 md:h-16 w-auto object-contain" />
            <div className="flex flex-col">

              <span className="text-foreground-50 font-bold font-heading text-base md:text-xl leading-tight">
                {companyInfo.name}
              </span>
              <span className="text-foreground-700 text-[10px] md:text-xs leading-tight tracking-wider">
                {companyInfo.englishName}
              </span>
            </div>
          </a>

              <div className="flex flex-col items-start lg:items-end gap-4">
                <div className="flex items-center gap-4">
                  <a
                    href={`tel:${companyInfo.phone}`}
                    className="w-10 h-10 rounded-full bg-background-200 border border-background-300/50 flex items-center justify-center text-primary-400 hover:bg-primary-500 hover:text-background-50 transition-all duration-200"
                    aria-label="電話"
                  >
                    <i className="ri-phone-line"></i>
                  </a>
                  {/* LINE */}
                  {/* <a
                    href="#contact"
                    className="w-10 h-10 rounded-full bg-background-200 border border-background-300/50 flex items-center justify-center text-primary-400 hover:bg-primary-500 hover:text-background-50 transition-all duration-200"
                    aria-label="LINE"
                  >
                    <i className="ri-chat-1-line"></i>
                  </a> */}
                </div>
              </div>
              
            </div>
            
          </div>
          <p className="text-foreground-700 text-xs text-center py-4">
                  &copy; 2026 {companyInfo.name} All Rights Reserved.
                </p>
        </div>
      </div>
    </footer>
  );
}